import type { Element } from 'html-react-parser';
import { camelCase, kebabCase } from 'lodash/fp';

const tag = 'rich-text-mount-point';
const TYPE_DATA_PROP = 'data-rte-type';

export function createMountPoint(type: string, data: Record<string, string>, children = '') {
    const dataEntries = Object.entries(data).map(([key, value]) => [toDataKey(key), value]);
    const typeEntry = [TYPE_DATA_PROP, type];
    const dataString = [typeEntry, ...dataEntries].map(([key, value]) => `${key}="${value}"`).join(' ');
    return `<${tag} ${dataString}>${children}</${tag}>`;
}

export function replaceMountPoint(
    el: Element,
    type: string,
    callback: (dataset: Record<string, string>) => React.ReactElement
) {
    if (el.name === tag && el.attribs[TYPE_DATA_PROP] === type) {
        const dataset = Object.entries(el.attribs)
            .filter(([key]) => key.startsWith('data-') && key !== TYPE_DATA_PROP)
            .reduce<Record<string, string>>((acc, [key, val]) => {
                acc[fromDataKey(key)] = val;
                return acc;
            }, {});
        return callback(dataset);
    }
}

const toDataKey = (key: string) => `data-${kebabCase(key)}`;
const fromDataKey = (key: string) => camelCase(key.replace('data-', ''));

export function escapeRegExp(string: string) {
    // https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
